import ES from './es';
import EN from './en';

const details = {
    ES,
    EN
};

export default details;
